import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConstantsService } from '../../constant/constants.service';
import { Beneficiaire } from 'src/app/shared/models/beneficiaire';
import { ImportResponse } from 'src/app/shared/models/api-response/import-response';
import { GenericCrudService } from '../../generic-crud.service';
import { HttpParams } from '@angular/common/http';
import { ListingResponse } from 'src/app/shared/models/listing/listing-response';

@Injectable({
	providedIn: 'root'
})
export class BeneficiaireService {
	constructor(
		private appConstants: ConstantsService,
		private genericCrudService: GenericCrudService
	) {}

	/**
	 * Renvoi la liste de tout les beneficiaires avec le minimum d'information (id, nom, prénom, care skill)
	 * @returns liste de beneficiaire
	 */
	getBeneficiairesMinimal(): Observable<Beneficiaire[]> {
		let queryParams = new HttpParams().append('light', true);
		const httpOptions = {
			params: queryParams
		};

		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.beneficiaireUrl}`,
			'getBeneficiaires',
			httpOptions
		);
	}

	/**
	 * Renvoi la liste de tout les beneficiaires avec le minimum d'information (id, nom, prénom, care skill)
	 * @returns liste de beneficiaire
	 */
	getBeneficiairesPageable(
		page: number,
		size: number,
		search: string,
		skills: string
	): Observable<ListingResponse> {
		let queryParams = new HttpParams();
		queryParams = queryParams.append('page', page);
		queryParams = queryParams.append('size', size);
		if (search) {
			queryParams = queryParams.append('search', search);
		}
		if (skills) {
			queryParams = queryParams.append('skill', skills);
		}

		const httpOptions = {
			params: queryParams
		};

		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.beneficiaireUrl}/page`,
			'getBeneficiaires',
			httpOptions
		);
	}

	/**
	 * Renvoie un beneficiaire en fonction de l'id transmie
	 * @param id id de l'utilisateur
	 * @returns beneficiaire
	 */
	getBeneficiaireById(id: number): Observable<Beneficiaire> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.beneficiaireUrl}/${id}`,
			'getBeneficiaireById'
		);
	}

	getBeneficiaireIdByOcasheId(ocasheId: number): Observable<number> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.beneficiaireUrl}/ocashe/${ocasheId}`,
			'getBeneficiaireIdByOcasheId'
		);
	}

	importBeneficiaires(file: File): Observable<ImportResponse> {
		const formData: FormData = new FormData();
		formData.append('file', file, 'beneficiaires.csv');
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.beneficiaireUrl}/import`,
			`importBeneficiaires`,
			formData
		);
	}

	importBeneficiairesFromOcashe(): Observable<void> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.beneficiaireUrl}/import/ocashe`,
			'importBeneficiairesFromOcashe'
		);
	}

	/**
	 * Met à jour un beneficiaire
	 * @param beneficiaire
	 * @returns
	 */
	updateBeneficiaire(beneficiaire: Beneficiaire): Observable<string> {
		return this.genericCrudService.genericPutDataToAPI(
			`${this.appConstants.beneficiaireUrl}`,
			`updateBeneficiaire`,
			beneficiaire
		);
	}

	/**
	 * Sauvegarde un beneficiaire
	 * @param beneficiaire
	 * @returns
	 */
	addBeneficiaire(beneficiaire: Beneficiaire): Observable<number> {
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.beneficiaireUrl}`,
			`addBeneficiaire`,
			beneficiaire
		);
	}

	/**
	 * Supprime un beneficiaire
	 * @param beneficiaireId
	 * @returns
	 */
	deleteBeneficiaire(beneficiaireId: number): Observable<string> {
		return this.genericCrudService.genericDeleteAPIDataByID(
			`${this.appConstants.beneficiaireUrl}/${beneficiaireId}`,
			`deleteBeneficiaire`
		);
	}
}
